import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function OkColorIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='10.4297' cy='10' r='10' fill='#8B33FF' />
      <path
        d='M15.5577 6.15332L8.5064 13.2046L5.30127 9.99947'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
